import { usePaging } from 'hooks/usePaging';
import { useGetUserGroupUsersQuery } from 'services';
import { FindOneUserGroupUsersDto } from 'types';
import { DEFAULT_PAGE_SIZE } from 'utils';
const pageSize = DEFAULT_PAGE_SIZE;
export function useUserGroupUsers(params: Omit<FindOneUserGroupUsersDto, 'pageIndex' | 'pageSize'>) {
  const { userGroupId, keyword, isLoadAll, endpoint } = params;
  const { pageIndex, changePage, resetPage } = usePaging(params);

  const {
    data: dataResponse,
    isLoading,
    isFetching
  } = useGetUserGroupUsersQuery({
    pageIndex: pageIndex,
    pageSize,
    userGroupId,
    keyword,
    isLoadAll,
    endpoint
  });

  const { rows, count } = dataResponse?.data || {};

  return {
    data: rows || [],
    count: count || 0,
    isLoading: isLoading || isFetching,
    pageIndex,
    pageSize,
    handleChangePage: changePage,
    resetPage
  };
}
